/**
 * 列表页底部的分页条。
 *
 * 抽出来的原因：操作日志、上位机授权记录、设备管理三个页面的骨架完全相同，但各自的
 * 禁用条件与文案写法略有出入（有的用 `p >= totalPages`，有的用 `p > totalPages`），
 * 结果是一处改了另两处忘改。分页逻辑只有一份，才不会漂移。
 */
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface PaginationProps {
  page: number
  totalPages: number
  total: number
  /** 单位后缀，如「条」「台」。 */
  unit?: string
  /** 拉取中时禁用翻页，避免连点。 */
  disabled?: boolean
  onChange: (page: number) => void
}

export function Pagination({
  page,
  totalPages,
  total,
  unit = '条',
  disabled = false,
  onChange,
}: PaginationProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="text-xs text-[var(--color-muted-foreground)]">
        第 {page} / {totalPages} 页，共 {total} {unit}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onChange(Math.max(1, page - 1))}
          disabled={page <= 1 || disabled}
        >
          <ChevronLeft className="size-4" />
          上一页
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages || disabled}
        >
          下一页
          <ChevronRight className="size-4" />
        </Button>
      </div>
    </div>
  )
}
